module.exports = __webpack_public_path__ + "static/pineapple-dehidrated-a321df61584663ac7954a91160dff089.png";